import { render, staticRenderFns } from "./SystemNotification.vue?vue&type=template&id=5c875a92&"
import script from "./SystemNotification.vue?vue&type=script&lang=js&"
export * from "./SystemNotification.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports